import { keyframes } from './stitches.config'

export const centered = keyframes({
    '0%': { transform: 'translate(-50%, -50%)' },
    '100%': { transform: 'translate(-50%, -50%)' },
})

export const fadeIn = keyframes({
    '0%': { opacity: 0, visibility: 'hidden' },
    '100%': { opacity: 1, visibility: 'visible' },
})

export const fadeOut = keyframes({
    '0%': { opacity: 1, visibility: 'visible' },
    '100%': { opacity: 0, visibility: 'hidden' },
})

export const scaleDown = keyframes({
    '0%': { transform: 'scale(1)' },
    '100%': { transform: 'scale(0.85)' },
})

export const scaleUp = keyframes({
    '0%': { transform: 'scale(0.85)' },
    '100%': { transform: 'scale(1)' },
})

export const spin = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
})

export const translateDown = keyframes({
    '0%': { transform: 'translateY(-4px)' },
    '100%': { transform: 'translateY(0)' },
})
